import PivotHomeContainer from "./PivotHomeContainer";
export default PivotHomeContainer;
